import React from 'react'

function TopCollectorsItem({ userPath, userProfileThumb, userName, COLLECTED}) {
    return (
        <div className="marketMoveStyle">
            <span>
            <a href={ userPath }><img className="MarketMoveUserThumb" src={userProfileThumb} alt={ userName }/></a>
            <a className="MarketMoveUserName" href={ userPath } className="username"><b>{ userName } </b></a>
            </span>
            <p><small className="countNumber">{ COLLECTED }</small></p>
        </div>
    )
}

export default TopCollectorsItem
